
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicStoreApi extends BaseModulePublicApi {
  basePath = 'items';
};
